exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-select-box[data-v-07c851f5] {\n  width: 100%;\n  border-color: #782b54;\n  border-radius:5px;\n  font-size: 13px;\n  width: 90%;\n  margin: auto;\n  text-align: center;\n  margin-top:10px;\n}\n.disabled-start-button[data-v-07c851f5] {\n  background-color: #b37499 !important;\n}\n", ""]);

// exports
